import { ExampleModelsList } from "../components/ExampleModelsList";
import { TrainModelForm } from "../components/TrainModelForm";

export function HomePage() {
  return (
    <section className="action-forms action-forms--two" aria-label="Get started">
      <article className="action-form-card action-form-card--max">
        <div className="deposit-heading deposit-heading--with-models">
          <h2 className="deposit-heading-text">Convert Your Data into AI Model(s)</h2>
          <span className="deposit-heading-alt">
            or Try running models <ExampleModelsList inline />
          </span>
        </div>
        <TrainModelForm compact lockedPath="train" />
      </article>
      {/* Placeholder column kept for grid CSS; no heavy form (was inflating page height). */}
      <article
        className="action-form-card action-form-card--minimized"
        aria-hidden="true"
      />
    </section>
  );
}
